import styled from 'styled-components';

const Subtext = styled.p`
  font-size: 12px;
`;
export default Subtext;
